/* Q Swimwear — Wishlist (favoritos) con localStorage.
   - Corazones de tarjeta (.q-card-wish) y de producto (.q-pdp-wish) guardan/quitan.
   - Estado activo persistente entre páginas y visitas.
   - Render de la sección Favoritos en la cuenta (#q-fav-grid).
   Sin app ni backend; por dispositivo/navegador. */
(function () {
  var KEY = 'q_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('q:wishlist:change', { detail: { count: list.length } }));
  }
  function has(id) { id = String(id); return read().some(function (x) { return String(x.id) === id; }); }
  function toggle(item) {
    if (!item || !item.id) return false;
    var list = read();
    var i = -1, n = list.length, k = String(item.id);
    for (var j = 0; j < n; j++) { if (String(list[j].id) === k) { i = j; break; } }
    if (i > -1) { list.splice(i, 1); write(list); return false; }
    list.unshift(item); write(list); return true;
  }
  function remove(id) {
    id = String(id);
    write(read().filter(function (x) { return String(x.id) !== id; }));
  }
  window.QWishlist = { read: read, has: has, toggle: toggle, remove: remove };

  function isLoggedIn() { return !!window.qLoggedIn; }
  // Guests must sign in / create an account before saving favorites.
  function promptSignIn() {
    var icon = document.querySelector('.nav-icon-account');
    if (icon) { icon.click(); }           // opens the branded sign-in drawer (has "Create account")
    else { window.location.href = '/account/login'; }
  }

  function itemFromBtn(btn) {
    return {
      id: btn.getAttribute('data-wish-id'),
      handle: btn.getAttribute('data-wish-handle'),
      title: btn.getAttribute('data-wish-title'),
      url: btn.getAttribute('data-wish-url'),
      price: btn.getAttribute('data-wish-price'),
      image: btn.getAttribute('data-wish-image')
    };
  }
  function syncBtn(btn) {
    var on = has(btn.getAttribute('data-wish-id'));
    btn.classList.toggle('is-active', on);
    btn.classList.toggle('is-liked', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  var SEL = '.q-card-wish[data-wish-id], .q-pdp-wish[data-wish-id]';

  // The card heart sits UNDER Dawn's full-card link overlay, so a real click lands
  // on the link (and navigates). We catch clicks in the capture phase at the document
  // level and, if the pointer is over a heart (even beneath the overlay), handle it
  // and cancel the navigation. This avoids fragile z-index/stacking fixes.
  function findHeart(e) {
    if (e.target && e.target.closest) {
      var direct = e.target.closest(SEL);
      if (direct) return direct;
    }
    var stack = document.elementsFromPoint ? document.elementsFromPoint(e.clientX, e.clientY) : [];
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      var b = (el.matches && el.matches(SEL)) ? el : (el.closest ? el.closest(SEL) : null);
      if (b) return b;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var btn = findHeart(e);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (!isLoggedIn()) { promptSignIn(); return; }
    toggle(itemFromBtn(btn));
    syncBtn(btn);
  }, true);

  function wire() {
    var btns = document.querySelectorAll(SEL);
    for (var i = 0; i < btns.length; i++) syncBtn(btns[i]);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function renderFav() {
    var grid = document.getElementById('q-fav-grid');
    if (!grid) return;
    var list = read();
    var count = document.getElementById('q-fav-count');
    if (count) count.textContent = list.length + (list.length === 1 ? ' saved' : ' saved');
    if (!list.length) {
      grid.innerHTML =
        '<div class="q-fav-empty"><p>You haven’t saved any favorites yet. Tap the heart on any product to save it here.</p>' +
        '<a class="qacc-btn" href="/collections/all">Start Shopping</a></div>';
      return;
    }
    var html = '';
    for (var i = 0; i < list.length; i++) {
      var x = list[i];
      html +=
        '<div class="q-fav-card" data-id="' + esc(x.id) + '">' +
          '<button class="q-fav-remove" type="button" aria-label="Remove from favorites">×</button>' +
          '<a class="q-fav-img" href="' + esc(x.url || '#') + '">' +
            (x.image ? '<img src="' + esc(x.image) + '" alt="' + esc(x.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="q-fav-info">' +
            '<a class="q-fav-name" href="' + esc(x.url || '#') + '">' + esc(x.title) + '</a>' +
            '<span class="q-fav-price">' + esc(x.price || '') + '</span>' +
          '</div>' +
          '<a class="q-fav-add" href="' + esc(x.url || '#') + '">View product</a>' +
        '</div>';
    }
    grid.innerHTML = html;
    var rms = grid.querySelectorAll('.q-fav-remove');
    for (var r = 0; r < rms.length; r++) {
      rms[r].addEventListener('click', function () {
        var card = this.closest('.q-fav-card');
        if (card) remove(card.getAttribute('data-id'));
      });
    }
  }

  function boot() { wire(); renderFav(); }

  document.addEventListener('q:wishlist:change', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // re-wire cards that load later (quick add, section reloads, infinite scroll)
  document.addEventListener('shopify:section:load', wire);
})();
